import { render, staticRenderFns } from "./choix-patient.html?vue&type=template&id=ebd6f1e2&scoped=true&external"
import script from "./choix-patient.js?vue&type=script&lang=js&external"
export * from "./choix-patient.js?vue&type=script&lang=js&external"
import style0 from "./choix-patient.scss?vue&type=style&index=0&id=ebd6f1e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd6f1e2",
  null
  
)

export default component.exports